import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { CapaComponent } from './views/capa/capa.component';
import { FirebaseGuard } from './firebase.guard';
import { FirebaseGuardAdm } from './firebase.guard.adm';
import { FirebaseGuardVendedor } from './firebase.guard.vendedor';
import { SobreNosComponent } from './views/sobre-nos/sobre-nos.component';
import { PreVestibularComponent } from './views/pre-vestibular/pre-vestibular.component';
import { FaleConoscoComponent } from './views/fale-conosco/fale-conosco.component';

export const routes: Routes = [

  
  {
    path: '',
    component: CapaComponent,
    data: {
      title: 'Grupo Cultural'
    }
  },
  {
    path: 'capa',
    component: CapaComponent,
    data: {
      title: 'Grupo Cultural'
    }
  },
  {
    path: 'home',
    component: CapaComponent,
    data: {
      title: 'Grupo Cultural'
    }
  },
  {
    path: 'sobre-nos',
    component: SobreNosComponent,
    data: {
      title: 'Sobre Nós'
    }
  },
  {
    path: 'pre-vestibular',
    component: PreVestibularComponent,
    data: {
      title: 'Pré Vestibular'
    }
  },
  {
    path: 'fale-conosco',
    component: FaleConoscoComponent,
    data: {
      title: 'Fale Conosco'
    }
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },

  {
    path: '',
    component: DefaultLayoutComponent,
    data: {},
    children: [
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule',
        canActivate: [FirebaseGuard],
        data: {
          title: 'Aulas'
        }
      },
      {
        path: 'meusdados',
        loadChildren: './views/meusdados/meusdados.module#MeusDadosModule',
        canActivate: [FirebaseGuard],
        data: {
          title: 'Meus Dados'
        }
      },
      {
        path: 'aulas',
        loadChildren: './views/aulas/aulas.module#AulasModule',
        canActivate: [FirebaseGuard],
        data: {
          title: 'Aulas'
        }
      },
      {
        path: 'biblioteca',
        loadChildren: './views/biblioteca/biblioteca.module#BibliotecaModule',
        canActivate: [FirebaseGuard],
        data: {
          title: 'Biblioteca Virtual'
        }
      },
      {
        path: 'gabaritos',
        loadChildren: './views/gabaritos/gabaritos.module#GabaritosModule',
        canActivate: [FirebaseGuard],
        data: {
          title: 'GabaritosVirtuais'
        }
      },
      {
        path: 'dashboardadm',
        loadChildren: './views/dashboardadm/dashboardadm.module#DashboardadmModule',
        canActivate: [FirebaseGuardAdm]
      },
      {
        path: 'curso',
        loadChildren: './views/curso/curso.module#CursoModule',
        canActivate: [FirebaseGuardAdm]
      },
      {
        path: 'materias',
        loadChildren: './views/materias/materias.module#MateriasModule',
        canActivate: [FirebaseGuardAdm]
      },
      {
        path: 'nivel',
        loadChildren: './views/nivel/nivel.module#NivelModule',
        canActivate: [FirebaseGuardAdm]
      }
      ,
      {
        path: 'aluno',
        loadChildren: './views/aluno/aluno.module#AlunoModule',
        canActivate: [FirebaseGuardAdm]
      }
      ,
      {
        path: 'vendedor',
        loadChildren: './views/vendedor/vendedor.module#VendedorModule',
        canActivate: [FirebaseGuardAdm]
      },
      {
        path: 'aluno-vendedor',
        loadChildren: './views/aluno-vendedor/aluno-vendedor.module#AlunoVendedorModule',
        canActivate: [FirebaseGuardVendedor]
      },
      {
        path: 'autor',
        loadChildren: './views/autor/autor.module#AutorModule',
        canActivate: [FirebaseGuardAdm]
      },
      {
        path: 'vestiba',
        loadChildren: './views/vestiba/vestiba.module#VestibaModule',
        canActivate: [FirebaseGuardAdm]
      },
      {
        path: 'banner',
        loadChildren: './views/banner/banner.module#BannerModule',
        canActivate: [FirebaseGuardAdm]
      },
      {
        path: 'simulado',
        loadChildren: './views/simulado/simulado.module#SimuladoModule',
        canActivate: [FirebaseGuardAdm]
      },      
      {
        path: 'fazer-simulado',
        loadChildren: './views/fazer-simulado/fazer-simulado.module#FazerSimuladoModule',
        canActivate: [FirebaseGuard]
      },      
      {
        path: 'pagina-simulado',
        loadChildren: './views/pagina-simulado/pagina-simulado.module#PaginaSimuladoModule',
        canActivate: [FirebaseGuard]
      }
    ]
  },
  { path: '**', component: P404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
  /*
    constructor(r: Router) {
      this.logaRotas('/', r.config);    
    }
  
    logaRotas(pai: String, rotas: Routes) {
      for (let i = 0; i < rotas.length; i++) {            
        if (rotas[i].children) {
          rotas[i].canActivate = [FirebaseGuard];        
          this.logaRotas(rotas[i].path + '/', rotas[i].children);
        }
      }
    }*/

}
